'use strict';

var _ = require('lodash');
var d3 = require('d3');
var Scales = function Scales(params, data) {
  var xMin = d3.min(data, function (element) {
    return Math.min(element.actualRate, element.optimalRate);
  });
  var xMax = d3.max(data, function (element) {
    return Math.max(element.actualRate, element.optimalRate);
  });
  var difference = xMax - xMin;
  var margin = difference * 0.043;
  var x = d3.scale.linear().domain([xMin - margin, xMax + margin]).range([0, params.width]);
  var y = d3.scale.ordinal().domain(_.map(data, 'class')).rangeBands([0, params.height], 0.3, 0.15);
  return {
    xScale: x,
    yScale: y
  };
};
Scales.$inject = [];
module.exports = Scales;